import gql from 'graphql-tag';

export default gql`
	query teamSearchV2(
		$first: Int
		$after: String
		$organizationId: ID!
		$query: String = ""
		$memberIds: [ID] = []
		$sortBy: [TeamSort]
		$siteId: String!
		$showEmptyTeams: Boolean = false
	) {
		team {
			teamSearch: teamSearchV2(
				first: $first
				after: $after
				organizationId: $organizationId
				filter: { query: $query, membership: { memberIds: $memberIds } }
				sortBy: $sortBy
				siteId: $siteId
				showEmptyTeams: $showEmptyTeams
			) @optIn(to: ["Team-search-v2"]) {
				nodes {
					...TeamNodeV2
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}

	fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;
